import log from "../helpers/log";

export default function(element, trigger, banner_name) {
	let flag = false;
	$(window).on("scroll", () => {
		if (flag) {
			return;
		}
		if ($(element).length == 0) {
			return;
		}
		//console.log($(element).offset().top, $(window).scrollTop(), $(window).height(),trigger);
		if (
			$(element).offset().top <=
			$(window).scrollTop() + $(window).height() + trigger
		) {
			flag = true;
			$.get(links.api.ads).then(
				function success(data) {
					$(element).html(data[banner_name]);
				},
				function fail(data, status) {
					log(__filename, { status });
				}
			);
		}
	});
}
